module.exports = __webpack_public_path__ + "img/sec5_11.bb418b38.jpg";